<template>
  <v-container class="User">
    <v-sheet
      min-height="300"
      rounded="lg"
      elevation="6"
    >
    <Toolbar
      :handle-reset="resetForm"
      :handle-submit="onSendForm"
      >

        <template slot="left">
          <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50"  >
            <h1><v-icon large>mdi-account</v-icon>{{ item['login'] }}</h1>
          </v-toolbar-title>
        </template>
    </Toolbar>

    <UserForm
      ref="updateForm"
      v-if="item"
      :values="item"
      :errors="violations"
      :loginActiv="false"
    />
    <Loading :visible="isLoading || deleteLoading" />
  </v-sheet>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import UserForm from '../../components/user/Form.vue';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import UpdateMixin from '../../mixins/UpdateMixin';

const servicePrefix = 'User';

export default {
  name: 'UserUpdate',
  servicePrefix,
  mixins: [UpdateMixin],
  components: {
    Loading,
    Toolbar,
    UserForm
  },

  computed: {
    ...mapFields('user', {
      deleteLoading: 'isLoading',
      isLoading: 'isLoading',
      error: 'error',
      updated: 'updated',
      violations: 'violations'
    }),
    ...mapGetters('user', ['find'])

  },

  methods: {
    ...mapActions('user', {
      deleteItem: 'del',
      retrieve: 'load',
      update: 'update',
    })
  }
};
</script>
